import { IAppState } from '@myStore/app.state';
import { IPeriodsChangesState } from '@myStore/periods-changes/periods-changes.state';
import { createSelector } from '@ngrx/store';

const periodsChangesSelector = (state: IAppState) => state.periodsChanges;

export const selectPeriodChangesLoading = createSelector(
  periodsChangesSelector,
  (state: IPeriodsChangesState) => state?.isLoading
);

export const selectPeriodChangesSuccess = createSelector(
  periodsChangesSelector,
  (state: IPeriodsChangesState) => state?.success
);

export const selectPeriodChangesFailure = createSelector(
  periodsChangesSelector,
  (state: IPeriodsChangesState) => state?.errors
);
